import type { Sex } from '@/types/app'

const mapping: Record<Sex, string> = {
  male: '男性',
  female: '女性',
  noAnswer: '無回答',
}

export const formatSex = (sex: Sex): string => mapping[sex]
